import { GroupedBalance, TokenBalance } from '@plug-core/providers/BalanceProvider'
import { ListGroup } from '@ui'
import React from 'react'
import { InTokenListContext, TokenListItem } from './TokenListItem'

interface IProps {
  balances: GroupedBalance[] | TokenBalance[]
  onTokenClick?: (tokenBalance: TokenBalance) => void
  showPriceChange: boolean
  /** Each token as its own bordered card with spacing between, instead of one grouped list. */
  separated?: boolean
}

export const TokenList = ({ balances, onTokenClick, showPriceChange, separated }: IProps) => {
  if (!balances.length) return null

  const items = balances.map((balance, i) => (
    <TokenListItem
      key={i}
      balance={balance}
      onClick={onTokenClick}
      showPriceChange={showPriceChange}
    />
  ))

  // Outside the list context each TokenListItem wraps itself in its own card.
  if (separated) return <div className="flex flex-col gap-2">{items}</div>

  return (
    <InTokenListContext.Provider value={true}>
      <ListGroup>{items}</ListGroup>
    </InTokenListContext.Provider>
  )
}
